<template>
  <div class='nowPlayingContainer' @click="$emit('click')">
    <img class="inductee_img"
    :src="overrideImage || '//classicalwalkoffame.org/inductees/' + inductee.ImageURL">
    <span class="nowplaying_text">{{ text }}</span><br>
    <div v-show="$root.deviceAudioSrc && (text === 'Device')" class="right-item" @click.stop>
      <sprite-button class="homeButton"
      @click="pause"
      :background-url="buttonImg"
      width="44px"
      height="39px"
      >Play</sprite-button>
      <br>
      <sprite-button
      @click="stop"
      background-url="img/stop_button.png"
      width="44px"
      height="39px"
      >Stop</sprite-button>
    </div>
    <span v-show="playing" class="name">{{ inductee.InducteeName }}<br></span>
    <span v-show="playing" class="song">{{ inductee.MusicTitle }}</span>
    <span v-show="!playing" class="noplay">Nothing playing, explore inductees below</span>
  </div>
</template>

<script>
export default {
  props: ['inductee', 'text', 'overrideImage'],
  computed: {
    buttonImg () {
      return this.$root.deviceAudioPaused ? 'img/play_button.png' : 'img/pause_button.png'
    },
    playing() {
      return this.inductee.InducteeName
    }
  },
  methods: {
    pause () {
      // Because we use stopPropagation we cannot just use @click="$root.togglePauseOnDevice()" directly.
      this.$root.togglePauseOnDevice()
    },
    stop () {
      this.$root.stopOnDevice()
    }
  }
}
</script>

<style lang="less">
.nowPlayingContainer {
  background: none;
  padding: 25px 0px 25px 0px;
  border-bottom: 1px solid #afd2ef;
  margin: 0px 0px 0px 0px;
  img.inductee_img {
    width: 60px;
    height: 60px;
    float: left;
    margin-right: 20px;
    margin-left: 20px;
  }
  .nowplaying_text {
    color: #9a4aaf;
    font-weight: bold;
    text-transform: uppercase;
    margin-bottom: -5px;
    font-size: 15px;
  }
  .name {
    color: #fff;
    font-family: "myriad-pro", arial, sans-serif;
    font-weight: bold;
    font-size: 16px;
  }
  .song {
    color: #afd2ef;
    font-family: "myriad-pro", arial, sans-serif;
    font-weight: normal;
    font-style: italic;
    font-size: 15px;
  }
  .noplay {
    color: white;
  }
  .sprite-button {
    display: inline-block;
    margin-left: -10px;
  }
  .right-item{
    float: right;
    margin-top: -28px;
  }
}

</style>